import React, { Component } from 'react';
import { Container, Row, Col, Table, Button, Badge, Alert, Form } from 'react-bootstrap';
import { hideUserDeletedNotification } from '../../redux/modules/notifications';
import AppSpinner from '../AppSpinner/AppSpinner';
import apiUrl from '../../utils/apiUrl';
import { connect } from 'react-redux';

const select = state => {
  return {
    token: state.auth.token,
    showNotification: state.notifications.showUserDeleted
  };
};

function mapDispatchToProps(dispatch) {
  return {
    hideUserDeletedNotification: () => dispatch(hideUserDeletedNotification())
  };
}

class ConnectedUsersComponent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      users: [],
      search: ''
    };
  }

  async componentDidMount() {

    const { token } = this.props;

    const usersResponse = await fetch(`${apiUrl}/admin/users?token=${token}`);
    const usersData = await usersResponse.json();

    if (usersData.success) {
      this.setState({
        users: usersData.users
      });
    }

    this.setState({ isLoading: false });

  }

  render() {

    const { users, isLoading, search } = this.state;
    const { history, showNotification, hideUserDeletedNotification } = this.props;

    const searchLowerCase = search ? search.toLowerCase() : '';

    const filteredUsers = !search ? users :
      users.filter(user => `${user.firstName} ${user.lastName}`.toLowerCase().includes(searchLowerCase) || user.email.toLowerCase().includes(searchLowerCase));

    if (isLoading) return (<AppSpinner />);

    return (
      <div className="table-info-component users-component">
        <Container>
          <Row>
            <Col xs={12}>

              {
                showNotification &&
                <Alert variant="info" onClose={hideUserDeletedNotification} dismissible>
                  <p>
                    El usuario se eliminó correctamente.
                  </p>
                </Alert>
              }

              <h2 className="header">Usuarios</h2>
              <hr />
            </Col>

            <Col xs={12}>

              <Form.Group style={{ width: '50%' }}>
                <Form.Control
                  type="text"
                  placeholder="Busca por nombre o correo"
                  value={search}
                  onChange={event => this.setState({ search: event.target.value })}
                />

              </Form.Group>

              <Table striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Correo</th>
                    <th>Nombre</th>
                    <th>Teléfono</th>
                    <th>Tipo</th>
                    <th>Editar</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    filteredUsers.map((user, index) =>
                      <tr key={user._id}>
                        <td>{index + 1}</td>
                        <td>{user.email}</td>
                        <td>
                          {
                            user.isBusiness ? user.businessName : `${user.firstName} ${user.lastName}`
                          }
                        </td>
                        <td>{user.cellPhone}</td>
                        <td>
                          {
                            user.isBusiness ?
                              <Badge variant="secondary">Persona jurídica</Badge> :
                              <Badge variant="success">Persona natural</Badge>
                          }

                        </td>
                        <td>
                          <Button
                            variant="info"
                            size="sm"
                            onClick={() => {
                              history.push(`/usuarios/${user._id}`);
                            }}
                          >
                            Editar
                          </Button>
                        </td>
                      </tr>
                    )
                  }
                </tbody>
              </Table>
            </Col>

          </Row>
        </Container>
      </div>
    );
  }
}

const UsersComponent = connect(select, mapDispatchToProps)(ConnectedUsersComponent);

export default UsersComponent;
